import { styled } from '@mui/material/styles';
import { Accordion } from '@mui/material';
import { BREAKPOINTS } from '@src/styles/config';

const StyledFAQ = styled('div')`
  width: 100%;
  max-width: ${(props) =>
    props.numberOfElements === 1
      ? '100%'
      : `calc((318px * ${props.numberOfElements || 1}) + (16px * ${
          (props.numberOfElements || 1) - 1
        }))`};
  margin-top: 80px;
  padding-bottom: 40px;
  background-color: #ffffff;
  border-radius: 16px;
  box-sizing: border-box;

  .faq-answer {
    a {
      color: #1c1c1ea3 !important;
    }
  }

  @media (max-width: ${BREAKPOINTS.LMD}px) {
    .faq-title {
      font-size: 20px;
      margin-bottom: 16px !important;
      line-height: 28px;
    }
    padding: 24px 16px;
    margin-top: 24px;

    .faq-question {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }

    .faq-answer {
      font-size: 14px;
      line-height: 20px;
    }
  }

  @media (max-width: 640px) {
    max-width: 100%;
    border-radius: 0;
    width: 100%;
  }
`;

const StyledAccordion = styled(Accordion)`
  margin-bottom: 16px !important;
  border-radius: 16px !important;
  border: 1px solid #1e164e29;
  padding: 16px !important;
  box-shadow: none !important;

  @media (max-width: ${BREAKPOINTS.LMD}px) {
    padding: 16px !important;
    border-radius: 12px !important;
    margin-bottom: 8px !important;
  }
`;

export { StyledFAQ, StyledAccordion };
